import { ChevronLeft, Send, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { WizardState } from "./types";

interface Props {
  state: WizardState;
  onNext: (updates: Partial<WizardState>) => void;
  onBack: () => void;
}

export default function StepTelegram({ onNext, onBack }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-foreground">
          Zustellung über Telegram oder WhatsApp
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          So bekommst du deine fertigen Stories zum eigenen Posten.
        </p>
      </div>

      <div className="rounded-xl border border-border bg-card p-6 space-y-4">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
            <Send className="h-5 w-5 text-primary" />
          </span>
          <div className="space-y-1">
            <p className="font-medium text-foreground">Deine Stories kommen aufs Handy</p>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Sobald dein Verein aktiv ist, senden wir jede fertige Story automatisch an dich,
              direkt aufs Handy, bereit zum Posten.
            </p>
          </div>
        </div>

        <div className="rounded-lg bg-muted/40 p-4">
          <p className="flex items-start gap-2 text-sm text-muted-foreground">
            <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
            <span>
              Die Einrichtung ist in 2 Minuten erledigt. Du erhältst die Anleitung nach der
              Registrierung per E-Mail. Jetzt musst du nichts tun.
            </span>
          </p>
        </div>
      </div>

      <div className="flex gap-2">
        <Button variant="outline" onClick={onBack} className="flex items-center gap-1">
          <ChevronLeft className="h-4 w-4" /> Zurück
        </Button>
        <Button variant="hero" className="flex-1" onClick={() => onNext({})}>
          Weiter →
        </Button>
      </div>
    </div>
  );
}
